module.exports = __webpack_public_path__ + "img/数据 (1).3c8f46ab.png";